export class ResponseStatusError extends Error {
  constructor(url: string, statusCode: number) {
    super(`Response status error (status code: ${statusCode}) when processing request to: ${url}`);
    this.name = 'ResponseStatusError';
  }
}
